import { render, staticRenderFns } from "./DateCarousel.vue?vue&type=template&id=47f8336c"
import script from "./DateCarousel.vue?vue&type=script&lang=js"
export * from "./DateCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports